var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "row--container",
      class: _vm.wrapClasses,
      attrs: {
        id: this.row.fields ? this.row.fields.row_id : "",
        "lazy-background": _vm.backgroundImage,
      },
    },
    [
      _c("div", { class: _vm.container }, [
        _vm.row?.fields?.content?.length > 0
          ? _c(
              "div",
              { ref: "contentWrap", class: _vm.rowClasses },
              [
                _vm._l(_vm.row.fields.content, function (entry, index) {
                  return [
                    entry?.sys?.contentType?.sys?.id === "modularColumn"
                      ? _c("Column", {
                          key: index + "column",
                          attrs: {
                            column: entry,
                            length: _vm.row.fields.content.length,
                          },
                        })
                      : entry?.sys?.contentType?.sys?.id === "devModule"
                      ? _c("DevModulesWrapper", {
                          key: index + "devmodule",
                          attrs: { modules: entry?.fields },
                        })
                      : entry?.sys?.contentType?.sys?.id === "carousel"
                      ? _c("CarouselWrapper", {
                          key: index + "carousel",
                          attrs: { carousel: entry.fields },
                        })
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isVideo
        ? _c(
            "div",
            { staticClass: "hero--video" },
            [
              _c("Video", {
                attrs: { video: this?.row?.fields?.backgroundImage?.fields },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }